var React = require('react');

function ClipboardPen (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"8","height":"4","x":"8","y":"2","rx":"1","key":0}),React.createElement("path",{"d":"M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5.5","key":1}),React.createElement("path",{"d":"M4 13.5V6a2 2 0 0 1 2-2h2","key":2}),React.createElement("path",{"d":"M13.378 15.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z","key":3})]);
}

ClipboardPen.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"lucide lucide-clipboard-pen-icon lucide-clipboard-pen"};

module.exports = ClipboardPen;

ClipboardPen.default = ClipboardPen;
